import { render, staticRenderFns } from "./RevenueRateSetup.vue?vue&type=template&id=16c05252&scoped=true"
import script from "./RevenueRateSetup.vue?vue&type=script&lang=js"
export * from "./RevenueRateSetup.vue?vue&type=script&lang=js"
import style0 from "./RevenueRateSetup.vue?vue&type=style&index=0&id=16c05252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c05252",
  null
  
)

export default component.exports